import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NavController, MenuController, ViewController, Events } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { ApiProvider } from '../../providers/api/api';
import { AnalyticsProvider } from '../../providers/analytics/analytics';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';

@Component({
  selector: 'common-header',
  templateUrl: 'common-header.html',
})
export class CommonHeaderComponent {
  @Input() text:string;
  @Input() page:string;
  @Input() is_toggle:boolean = false;
  @Input() hide_back:boolean = true;
  @Input() is_close:boolean = false;
  @Input() top_tab_shop_id:number;
  @Output() returnMap = new EventEmitter<boolean>();
  @Output() returnFavorite = new EventEmitter<boolean>();
  service_data = [];
  is_pc:boolean;
  header_color:string = '#000000';
  header_background_color:string = '#4e8ef7';
  header_image:string;
  header_image_url:string;
  header_data = [];
  new_push:number;
  header_height:string;
  is_login:boolean;
  is_map_active:boolean = false;
  is_favorite_active:boolean = false;
  is_map_icon:boolean = false;
  main_list = [];
  sub_list = [];
  pc_data = [];
  top_tab_list = [];
  top_tab_active_index = 0;
  is_preview = 0;
  @ViewChild('top_tab_menu') top_tab_menu:any;

  constructor(
    public navCtrl: NavController,
    public menu: MenuController,
    public viewCtrl: ViewController,
    public events: Events,
    public comProv: CommonProvider,
    public apiProv: ApiProvider,
    public gaProv: AnalyticsProvider,
  ) {
    this.service_data = this.comProv.getService();
    this.is_pc = this.comProv.isPc();
    this.is_preview = this.comProv.getOptionsValue('is_preview');
    this.events.subscribe('drawer:set', () => {
      this.setDrawer();
    });
  }

  ngOnInit () {
    if (!this.comProv.platform.is('mobile')) {
      this.menu.enable(false);
    }
    this.is_login = this.comProv.isLogin();
    this.getTopTab();
    this.setHeader();
    this.setDrawer();
    
    if (this.page != 'PushIndexPage') {
      this.checkDailyAccess();
    }
  }

  setDrawer() {
    if (this.top_tab_shop_id) {
      this.text =  this.service_data['name'];
      return;
    }
    let drawer_list = this.comProv.getDrawer();
    let check_page = this.page;
    if (this.page == 'ShopDetailPage') {
      check_page = 'ShopIndexPage';
    }
    let drawer_data = drawer_list.find((item) => {
      return (item['page_target'] == check_page);
    });
    if (drawer_data) {
      if (drawer_data['title']) {
        this.text = drawer_data['title'];
      }
    }

    drawer_list = drawer_list.filter(item => item['is_privated'] != 1);
    let color_list = this.comProv.getColor();
    this.main_list = [];
    this.sub_list  = [];
    drawer_list.forEach(function(item, index) {
      if (item['page_target'] == this.page) {
          item['is_active'] = true;
          item['color'] = color_list['button_background'];
          item['border_color'] = color_list['button_background'];
      }
      if (index < 6) {
        this.main_list.push(item);
      } else {
        this.sub_list.push(item);
      }
    }, this);
  }

  setHeader() {
    let color_list = this.comProv.getColor();

    this.header_color = color_list['header_color'];
    this.header_background_color = color_list['header_background'];
    
    if ((this.page == 'HomePage' || this.page == 'SharePage' || this.top_tab_list.length) && color_list['header_image']) {
      this.text  = '';
      
      this.header_image = 'url(' + color_list['header_image'] + ')';
      let height = String(window.parent.screen.width / 6);
      this.header_height = height + 'px';
    }
    if (color_list['header_image']) {
      this.header_image_url = color_list['header_image'];
    }
    if (this.page == 'HomePage') {
      this.header_data = this.comProv.getHeaderData();
      console.log('header_data', this.header_data);
    }

    this.pc_data = this.comProv.getPcData();

    // iOSフッター隙間対策
    if (localStorage.getItem('footer_background_color')) {
      let footer_background_color = localStorage.getItem('footer_background_color');
      let style_text = 'body{background-color:' + footer_background_color + ';}';
      let style = document.createElement('style');
      style.textContent = style_text;
      document.head.appendChild(style);
    }
  }

  checkDailyAccess() {
    if (this.is_pc || !this.is_login) {
      return;
    }
    if (!this.service_data['is_score'] || !this.service_data['daily_access_score_rule']) {
      return;
    }

    let now_time = new Date().getTime();
    if (now_time < this.comProv.getTimestamp(this.service_data['daily_access_score_rule']['start_at'])) {
      return;
    }
    if (now_time > this.comProv.getTimestamp(this.service_data['daily_access_score_rule']['end_at'])) {
      return;
    }

    let access_day = this.comProv.getOptionsValue('access_day');
    let today = this.comProv.formatDate(new Date(), 'YYYY/MM/DD') + ' 00:00:00';

    if (!this.comProv.checkTime(access_day, today, null)) {
      return;
    }
    this.setDailyAccess();
  }

  setDailyAccess() {
    this.apiProv.post(this.service_data['_links']['score']['daily_access_store']['href'])
    .then(data => {
      if (data['statusCode'] != '000') {
        this.apiProv.detaError(data);
        return;
      }

      let access_day = data['data']['created_at'].replace(/-/g, '/').substr(0, 10) + ' 00:00:00';
      this.comProv.setOptions('access_day', access_day);
    }).catch(error => {
      //this.apiProv.statusError(error, this.navCtrl);
    });
  }

  setPush(new_push) {
    this.new_push = new_push;
  }

  goPush() {
    if (location.hash == '#/push-index') {
      return;
    }
    this.navCtrl.setRoot('PushIndexPage');
  }

  goPage() {
    let data = {
      url: this.header_data['header_icon_url1'],
      target: this.header_data['header_icon_target1'],
      current_page: this.page,
      category: 'ヘッダーアイコン'
    };
    this.comProv.goPage(data, this.navCtrl, this.gaProv);
  }

  setShopMap() {
    if (this.is_map_active) {
      this.is_map_active = false;
    } else {
      this.is_map_active = true;
    }
    this.returnMap.emit(this.is_map_active);
  }

  setShopFavorite() {
    if (this.is_favorite_active) {
      this.is_favorite_active = false;
    } else {
      this.is_favorite_active = true;
    }
    this.returnFavorite.emit(this.is_favorite_active);
  }

  close() {
    this.viewCtrl.dismiss();
  }

  goPagePc(item) {
    this.comProv.goPagePc(item, this.navCtrl, this.page);
  }

  mouseOver(item) {
    let color_list = this.comProv.getColor();

    item['color'] = color_list['button_background'];
    item['border_color'] = color_list['button_background'];
  }

  mouseOut(item) {
    if (item['is_active']) {
      return;
    }

    item['color'] = '#000000';
    item['border_color'] = '#ffffff';
  }

  setMapIcon() {
    this.is_map_icon = true;
  }

  getTopTab() {
    if (this.comProv.isPc()) {
      return;
    }
    if (!this.service_data['option']) {
      return;
    }
    if (!this.service_data['option']['is_top_tab']) {
      return;
    }
    if (this.service_data['option']['is_top_tab'] != '2') {
      if (!this.comProv.isLogin()) {
        return;
      }
    }
    if (!this.page) {
      return;
    }
    if (this.page != 'HomePage' && this.page.indexOf('FreeIndexPage-') !== 0) {
      return;
    }

    let top_tab_list = this.comProv.getTopTab();
    if (top_tab_list.length < 1) {
      return;
    }

    if (this.page.indexOf('FreeIndexPage-') === 0) {
      if (this.top_tab_shop_id　< 1) {
        return;
      }

      let find_result = top_tab_list.find((item) => {
        return (item['page_target'] == this.page);
      });
      if (!find_result) {
        return;
      }
    }

    this.top_tab_list = top_tab_list;
    this.setTopTab();
  }

  setTopTab() {
    let color_list = this.comProv.getColor();

    for (let i=0; i<this.top_tab_list.length; i++) {
      let is_active = false;
      if (this.top_tab_list[i]['page_target'] == 'HomePage') {
        if (this.page == 'HomePage') {
          is_active = true;
        }
      } else {
        if (this.top_tab_list[i]['id'] == this.top_tab_shop_id) {
          is_active = true;
        }
      }

      if (is_active) {
        this.top_tab_list[i]['bottom_color'] = color_list['button_background'];
        this.top_tab_list[i]['font_weight'] = 'bold';
        this.top_tab_active_index = i;
      } else {
        this.top_tab_list[i]['bottom_color'] = 'transparent';
        this.top_tab_list[i]['font_weight'] = 'normal';
      }
    }

    // タブメニューの移動
    setTimeout(() => {
      let index = this.top_tab_active_index;
      let start = this.top_tab_menu.nativeElement.scrollLeft;
      if (index > 0) {
        index = index - 1;
      }
      let end = this.top_tab_menu.nativeElement.children[index].offsetLeft;
      let dir = 1;
      // 進行方向を決定(1：進む、-1：戻る)
      if(start > end){
          dir = dir * -1;
      }
      // 移動量を決める。
      let speed = Math.abs(end - start) / 20;
      let cnt = 0;
      // endの位置に来るまでループ
      let obs = Observable.interval(1).subscribe((x) => {
          cnt = cnt + (speed * dir);
          this.top_tab_menu.nativeElement.scrollLeft = start + cnt;
          // 進む場合
          if((start+cnt) >= end && dir == 1){
              obs.unsubscribe();
          }
          // 戻る場合
          if((start+cnt) <= end && dir == -1){
              obs.unsubscribe();
          }
      });
    }, 1)
  }

  changeTopTab(next_tab_data) {
    let now_tab_data = this.top_tab_list[this.top_tab_active_index];    
    this.top_tab_shop_id = next_tab_data['id'] ? next_tab_data['id'] : null;
    
    if (next_tab_data['id'] != now_tab_data['id'] && next_tab_data['page_target'] == now_tab_data['page_target']) {
      this.setTopTab();
      return;
    }

    next_tab_data['target']          = next_tab_data['page_target'];
    next_tab_data['current_page']    = this.page;
    next_tab_data['category']        = 'ヘッダータブ';
    next_tab_data['top_tab_shop_id'] = this.top_tab_shop_id;
    this.comProv.goPage(next_tab_data, this.navCtrl, this.gaProv);
  }

  cancelPreview() {
    this.comProv.setOptions('is_preview', 0);
    this.comProv.restart();
  }

  restartPreview() {
    this.comProv.restart();
  }
}


// WEBPACK FOOTER //
// ./src/components/common-header/common-header.ts